import CwXlsxPreview from "./index.vue"

export default CwXlsxPreview